import React from 'react'
import { useState } from 'react';
import toast from 'react-hot-toast';
import { API_URL } from '../apiConfig';

//components import here :)
import SubmitButton from '../Components/SubmitButton';


//Form Components :)
import Form from '../Components/FormComponents/Form';
import FormInput from '../Components/FormComponents/FormInput';
import FormDropdown from '../Components/FormComponents/FormDropDown';


const Homepage = () => {
    const name = process.env.REACT_APP_NAMEOFOWNER;
    const hotel = process.env.REACT_APP_NAMEOFPROJECT
    const [email, setEmail] = useState('');
    const [character, setCharacter] = useState('');
    const [show, setShow] = useState('');
    const [frequency, setFrequency] = useState('');
    const [dailyTime, setDailyTime] = useState('');
    const [type, setType] = useState('');
    const [notes, setNotes] = useState('');

      const [isSubmitting, setIsSubmitting] = useState(false);
   const handleSubmit = async () => {
        setIsSubmitting(true);

        const formData = {
            email,
            character_name: character,
            character_series: show,
            message_type: type,
            frequency,
            daily_time: dailyTime,
            notes
        };

        try {
            const response = await fetch(`${API_URL}/api/subscribe`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (response.ok) {
                toast.success('Success! Check your email for confirmation! 💖✨', {
                    duration: 5000,
                    style: {
                        background: 'linear-gradient(to right, #ec4899, #a855f7, #3b82f6)',
                        color: '#fff',
                        fontWeight: 'bold',
                        padding: '16px',
                        borderRadius: '12px',
                    },
                });
           
                setEmail('');
                setCharacter('');
                setShow('');
                setType('');
                setFrequency('');
                setDailyTime('');
                setNotes('');
            } else {
                toast.error(`Oops! ${typeof data.detail === 'string' ? data.detail : data.message || 'Please check your form fields'} 😢`);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error('Failed to submit. Please try again! 💔');
        } finally {
            setIsSubmitting(false);
        }
    };
     
    
    

    return (
         <div className="min-h-screen bg-gradient-to-br from-pink-200 via-purple-200 to-blue-200 p-4 sm:p-8">
        <div className="max-w-2xl mx-auto bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl p-4 sm:p-8">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-4 sm:mb-6 text-center bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 bg-clip-text text-transparent font-cookie">
                Welcome to {hotel}!! ✨
            </h1>
            
            <article className="mb-6 sm:mb-8 leading-relaxed text-base sm:text-lg space-y-3 sm:space-y-4">
                <p className="text-pink-600 font-semibold">
                    Hi!! My name is <span className="text-purple-600 font-pacifico">{name}</span>!! 💖
                </p>
                <p className="text-purple-700">
                    I made this really cool tool that lets you get messages from your Favourite characters!! Sometimes we all just need a little bit of silliness in our lives, it can make a huge difference in how you feel when vibing day to day. So if you'd like, feel free to sign up!! 
                </p>
                <p className="text-blue-600 font-medium">
                    Sooo if that sounds cool, just fill out the form below, click the confirm button on the confirmation email you get (Might end up in spam but promise its not spam!!!) and then you are all done!!! 🌈
                </p>
            </article>

                <Form onSubmit={handleSubmit}>
                    <FormInput
                        label="What's your Email address? 💌"
                        type="email"
                        placeholder="yourawesomeemail@something.com ✨"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <FormInput
                        label="Who's a character you'd love to Email you? 🌟"
                        type="text"
                        placeholder="e.g., Vox, Tails, Tanjiro etc..💫"
                        required
                        value={character}
                        onChange={(e) => setCharacter(e.target.value)}
                    />

                    <FormInput
                        label="What medium is this character from? 📺"
                        type="text"
                        placeholder="e.g., Hazbin Hotel, Sonic the Hedgehog, Demon Slayer 🎬"
                        required
                        value={show}
                        onChange={(e) => setShow(e.target.value)}
                    />
                    
                    <FormDropdown
                        label="What Type of Emails Would you like to see? 💭"
                        options={[
                            { value: 'uplift', label: '✨ Gimme uplifting messages' },
                            { value: 'motivational', label: '🫡 Gimme motivational messages' },
                            { value: 'checkins', label: '👋 Gimme "Hey Hows it going?" messages' },
                            { value: 'funny', label: '😁 Gimme funny messages' },
                            { value: 'mentalhealth', label: '❤️ Gimme mental health tips' }
                        ]}
                        required
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                    />

                    <FormInput 
                        label="Anything about yourself or the character you have chosen you would like to share? 📝"
                        type="text"
                        placeholder="Tell us more so we can personalize your experience! 🎨"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                    />

                    <FormDropdown
                        label="How often would you like to receive emails? 📬"
                        options={[
                            { value: 'daily', label: '☀️ Daily' },
                            { value: 'weekly', label: '🌸 Weekly' },
                            { value: 'monthly', label: '🌙 Monthly' },
                        ]}
                        required
                        value={frequency}
                        onChange={(e) => setFrequency(e.target.value)}
                    />

                    {frequency === 'daily' && (
                        <FormDropdown
                            label="What time of day? ⏰"
                            options={[
                                { value: 'morning', label: '🌅 Mornings' },
                                { value: 'bedtime', label: '🌙 Bedtimes' },
                                { value: 'both', label: '☀️🌙 Morning and Bedtimes' },
                            ]}
                            required
                            value={dailyTime}
                            onChange={(e) => setDailyTime(e.target.value)}
                        />
                    )}

                    <SubmitButton 
                        disabled={isSubmitting}
                        label={isSubmitting ? "Submitting... ✨" :"Get Started with Fandom Fun!!!!!!"}
                    />
                </Form>
            </div>
        </div>
    );
}

export default Homepage;
